import { Pipe, PipeTransform } from '@angular/core';
import { EAirRatingDetailNames, IAirRatingDetail } from "../../model/air-quote/IQuote";

@Pipe({
    name: 'findDetail'
})
export class FindDetailPipe implements PipeTransform {
    public transform(details: IAirRatingDetail[], detailName: EAirRatingDetailNames): IAirRatingDetail {
        //TODO EJ virer ce Object.values() une fois l'API corrigée
        return Object.values(details)
            .find((detail: IAirRatingDetail) => detail.code === detailName);
    }
}
